import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Drawer } from "antd";
import { withTranslation } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
} from "./styles";
import OptInLoginDialog from "../OptInLoginDialog";
import { useUser } from "../../contexts/userContext";
import ProfileDropdown from "../ProfileDropdown";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../redux/slices/authSlice";
import { setOptInLoginDialog,
  selectUserState,
} from "../../redux/slices/userSlice";
import { trackEvent } from "../../utils/analytics";

const Header = ({ t }: any) => {
  const [visible, setVisibility] = useState(false);
  const { optInLoginDialog } = useSelector(selectUserState);
  const history = useHistory();
  const dispatch = useDispatch();
  const { loggedInUser } = useUser();

  useEffect(() => {
    setVisibility(false);
  }, [history.location.pathname]);
  
  // COMMENTED OUT: Login/Signup functionality disabled
  // const handleDialogOpen = () => {
  //   dispatch(setOptInLoginDialog({open: true, mode: "login"}));
  // }

  // const handleDialogClose = () => {
  //   dispatch(setOptInLoginDialog({open: false}));
  // }

  // const footer = {
  //   onSubmit: () => {
  //     dispatch(login({
  //       params: { email: 'dd', password: 'dd' },
  //       method: {
  //         url: '/auth/login',
  //         action: 'POST',
  //       },
  //     }));
  //   },
  //   submitText: 'Login',
  //   cancelText: 'Cancel',
  //   canSubmit: true,
  // };

  const buttonAction = () => {
    // MODIFIED: Allow all users to report outages without login
    scrollTo("reportOutage");
    // if (loggedInUser) {
    //   scrollTo("reportOutage");
    // } else {
    //   trackEvent("login-attempt", {});
    //   handleDialogOpen();
    // }
    setVisibility(false);
  }

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const scrollTo = (id: string) => {
    if (id.indexOf('/') === 0) {
      navigate(id);
    } else {
      if (history.location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          const element = document.getElementById(id);
          if (element) {
            element.scrollIntoView({
              behavior: "smooth",
            });
          }
        }, 2500);
      } else {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
          });
        }
      }
    }
    setVisibility(false);
  };

  const MenuItem = () => {
    
    return (
      <>
        <CustomNavLinkSmall onClick={() => {
          setVisibility(false);
          navigate("/");
        }}>
          <Span>{t("Home")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => {
          trackEvent('btn_cta_click', {
            button_name: 'Outage List',
            info: 'cta on header'
          });
          setVisibility(false);
          navigate("/outages/list");
        }}>
          <Span>{t("Outage List")}</Span>
        </CustomNavLinkSmall>
        {/* COMMENTED OUT: Pricing link disabled */}
        {/* {!loggedInUser && (
          <CustomNavLinkSmall onClick={() => {
            trackEvent('btn_cta_click', {
              button_name: 'Pricing',
              info: 'cta on header'
            });
              scrollTo("pricing");
          }}>
            <Span>{t("Pricing")}</Span>
          </CustomNavLinkSmall>
        )} */}
        <CustomNavLinkSmall onClick={() => {
          trackEvent('btn_cta_click', {
            button_name: 'Blog',
            info: 'cta on header'
          });
          setVisibility(false);
          navigate("/blog/kplc-scheduled-outages/latest");
        }}>
          <Span>{t("Blog")}</Span>
        </CustomNavLinkSmall>
        {/* COMMENTED OUT: ProfileDropdown and Login button disabled */}
        {/* {loggedInUser ? (
          <CustomNavLinkSmall style={{ width: "180px"  }}>
            <ProfileDropdown />
          </CustomNavLinkSmall>
        ) : (
          <CustomNavLinkSmall style={{ width: "180px" }} onClick={buttonAction}>
            <Span>
              <Button>{t("Login")}</Button>
            </Span>
          </CustomNavLinkSmall>
        )} */}
      </>
    );
  };

  const navigate = (path: string) => {
    history.push(path); // Navigate function
    setVisibility(false);
  };

  return (
    <>
      <HeaderSection>
        <Container>
          <Row justify="space-between">
            <LogoContainer to="/" aria-label="homepage">
              <SvgIcon src="logo.svg" width="150px" height="40px" />
            </LogoContainer>
            <NotHidden>
              <MenuItem />
            </NotHidden>
            <Burger onClick={toggleButton}>
              <Outline />
            </Burger>
          </Row>
          <Drawer closable={false} open={visible} onClose={toggleButton}>
            <Col style={{ marginBottom: "2.5rem" }}>
              <Label onClick={toggleButton}>
                <Col span={12}>
                  <Menu>Menu</Menu>
                </Col>
                <Col span={12}>
                  <Outline />
                </Col>
              </Label>
            </Col>
            <MenuItem />
          </Drawer>
        </Container>
      </HeaderSection>
      {/* COMMENTED OUT: OptInLoginDialog disabled */}
      {/* {optInLoginDialog.open && <div style={{ position: 'fixed', zIndex: 1050 }}>
        <OptInLoginDialog
          dialogOpen={optInLoginDialog.open}
          closeDialog={handleDialogClose}
          openTo="login"
          footerActions={footer}
        />
      </div>} */}
    </>
  );
};

export default withTranslation()(Header);
